var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2062 5.94801L8.16536 11.9888L4.87453 8.70717L3.58203 9.99967L8.16536 14.583L15.4987 7.24967L14.2062 5.94801ZM9.9987 0.833008C4.9387 0.833008 0.832031 4.93967 0.832031 9.99967C0.832031 15.0597 4.9387 19.1663 9.9987 19.1663C15.0587 19.1663 19.1654 15.0597 19.1654 9.99967C19.1654 4.93967 15.0587 0.833008 9.9987 0.833008ZM9.9987 17.333C5.94703 17.333 2.66536 14.0513 2.66536 9.99967C2.66536 5.94801 5.94703 2.66634 9.9987 2.66634C14.0504 2.66634 17.332 5.94801 17.332 9.99967C17.332 14.0513 14.0504 17.333 9.9987 17.333Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.f882a8ebabd28f3f401dd63b9ad46033.svg";
export { ForwardRef as ReactComponent };